import type { FilterOptionType } from '@providers/FilterProvider';
import type { Dict, MaybeArrayItem } from '@types';
import { createClsNameMap, toItemArray } from '@utils';

import type { FilterOptionProps } from '../FilterOption';
import FilterOption from '../FilterOption';
import type { FilterOptionSwatchItemProps as OptionItemProps } from './OptionItem';
import FilterOptionSwatchItem from './OptionItem';

export const clsNameMap = createClsNameMap()('filter-option-swatch');

export type FilterOptionSwatchProps<FilterOption extends FilterOptionType> = {
  option: FilterOption;
  filterOptionProps?: Partial<FilterOptionProps>;
  filterOptionItemProps: (
    optionItem: MaybeArrayItem<FilterOption['values']>
  ) => Pick<OptionItemProps, 'value'>;
  fileBaseUrl: string;
  swatchSettings: Dict;
};

const FilterOptionSwatch = <FilterOption extends FilterOptionType>({
  option,
  filterOptionProps,
  filterOptionItemProps,
  fileBaseUrl,
  swatchSettings,
}: FilterOptionSwatchProps<FilterOption>) => {
  const listItemModifiers: Array<'list' | 'inline'> = option.swatchStyle?.includes('list')
    ? ['list']
    : ['inline'];

  return (
    <FilterOption
      option={option}
      {...filterOptionProps}
      className={clsNameMap.root()}
      listItemModifiers={listItemModifiers}
    >
      {({ filterOptions }) => {
        return toItemArray(filterOptions).map((optionItem) => {
          const optionItemProps = filterOptionItemProps(optionItem);
          return (
            <FilterOptionSwatchItem
              docCount={optionItem.doc_count}
              key={optionItemProps.value}
              filterOptionId={option.filterOptionId}
              filterOptionLabel={option.label}
              {...optionItemProps}
              {...filterOptionProps}
              option={option}
              fileBaseUrl={fileBaseUrl}
              swatchSettings={swatchSettings}
            />
          );
        });
      }}
    </FilterOption>
  );
};

export default FilterOptionSwatch;
